import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import * as ActionTypes from '../constants/actionTypes'
import * as API from '../constants/api'

export const reservationRoomCreate = createAsyncThunk(
  ActionTypes.RESERVATION_ROOM_CREATE,
  async (params: PayloadCreatorParams<`${typeof API.RESERVATION_ROOM}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.reservationRoomCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const reservationRoomAll = createAsyncThunk(
  ActionTypes.RESERVATION_ROOM_ALL,
  async (
    params: PayloadCreatorParams<`${typeof API.RESERVATION_ROOM_ALL}`, 'get'> | undefined,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.reservationRoomAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const reservationRoomDelete = createAsyncThunk(
  ActionTypes.RESERVATION_ROOM,
  async (params: PayloadCreatorParams<`${typeof API.RESERVATION_ROOM}{id}`, 'delete'>, { rejectWithValue }) => {
    try {
      const response = await api.reservationRoomDelete(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const reservationRoomList = createAsyncThunk(
  ActionTypes.RESERVATION_ROOM_LIST,
  async (params: PayloadCreatorParams<`${typeof API.RESERVATION_ROOM}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.reservationRoomList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const reservationTimeSlotAll = createAsyncThunk(
  ActionTypes.RESERVATION_TIME_SLOT_ALL,
  async (params: PayloadCreatorParams<`${typeof API.RESERVATION_TIME_SLOT_ALL}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.reservationTimeSlotAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const roomReservationCreate = createAsyncThunk(
  ActionTypes.ROOM_RESERVATION,
  async (params: PayloadCreatorParams<`${typeof API.ROOM_RESERVATION}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.roomReservationCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const roomReservationAll = createAsyncThunk(
  ActionTypes.ROOM_RESERVATION_ALL,
  async (
    params: PayloadCreatorParams<`${typeof API.ROOM_RESERVATION_ALL}`, 'get'> | undefined,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.roomReservationAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const roomReservationDelete = createAsyncThunk(
  ActionTypes.ROOM_RESERVATION_DELETE,
  async (params: PayloadCreatorParams<`${typeof API.ROOM_RESERVATION}{id}`, 'delete'>, { rejectWithValue }) => {
    try {
      const response = await api.roomReservationDelete(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const reservationRoomAllClear = createAction(`${ActionTypes.RESERVATION_ROOM}/clear`)
export const reservationRoomListClear = createAction(`${ActionTypes.RESERVATION_ROOM_LIST}/clear`)
